module.exports = __webpack_public_path__ + "img/appstore.67923e0e.svg";